// removed by extract-text-webpack-plugin
module.exports = {"ba-modal":"magazines_1PaJY","ba-subtitle":"magazines_2-z34","no-resize":"magazines_2p52J","ba-modal-card":"magazines_1biHc","ba-relative":"magazines_11dX9","ba-img":"magazines_3GAoa","ba-absolute":"magazines_sPhH1","ba-none":"magazines_2ZE41"};


//////////////////
// WEBPACK FOOTER
// ./src/components/EmbedMagazine/styles.scss
// module id = 1016
// module chunks = 1